import IconAnimation from "./IconAnimation";

export default IconAnimation;
